import { Box } from "@mui/material";
import type { FC } from "react";

export interface RibbonProps {
  label: string;
  size?: "small" | "medium";
}

export const Ribbon: FC<RibbonProps> = ({ label, size = "medium" }) => {
  const ribbonSmall = size === "small";

  return (
    <Box
      sx={{
        position: "absolute",
        fontWeight: "500",
        fontSize: ribbonSmall ? "7pt" : "10pt",
        lineHeight: ribbonSmall ? "9pt" : "14pt",
        bottom: ribbonSmall ? "12.5%" : "12.5px",
        left: ribbonSmall ? "-25%" : "-25px",
        width: ribbonSmall ? "100%" : "100px",
        textAlign: "center",
        pointerEvents: "none",
        color: (theme) => theme.palette.primary.contrastText,
        background: (theme) => theme.palette.primary.dark,
        transform: "rotate(45deg)",
        zIndex: 1,
      }}
    >
      {label}
    </Box>
  );
};
